import type { Planungsfrage } from '../types';

/** Ids der Belege, auf die Antworten verweisen — ohne Doppelte. */
export const belegIds = (fragen: readonly Pick<Planungsfrage, 'antwort_beleg_id'>[]): string[] =>
    Array.from(new Set(fragen.map(f => f.antwort_beleg_id).filter((id): id is string => !!id)));

/**
 * Titel der Belege fuer die Quellenzeile im PDF (id → Titel, sonst
 * Dateiname). Nur Belege, auf die eine Antwort verweist; ein Dokument, das
 * es in der Ablage nicht mehr gibt, fehlt in der Karte — das Modell schreibt
 * dann „Beleg in der Ablage".
 */
export const belegTitelAus = (
    dokumente: readonly { id: string; titel?: string | null; dateiname?: string | null }[],
    fragen: readonly Pick<Planungsfrage, 'antwort_beleg_id'>[],
): Record<string, string> => {
    const gesucht = new Set(belegIds(fragen));
    const karte: Record<string, string> = {};
    dokumente.forEach(d => {
        if (!gesucht.has(d.id)) return;
        const titel = String(d.titel || '').trim() || String(d.dateiname || '').trim();
        if (titel) karte[d.id] = titel;
    });
    return karte;
};
